import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import ShoppingCartItem from "../../components/ShoppingCartItem/ShoppingCartItem";
import { countQuantityCart } from "../../services/cartShoppingService";
import { RootState } from "../../store/store";
import "./Order.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Order = () => {
  const { shoppingCart } = useSelector((state: RootState) => state.cart);
  const navigate = useNavigate();

  return (
    <div className="order">
      <h2>VOTRE PANIER</h2>
      <div>
        <div>
          <p>PRODUITS</p>
          <div className="shopping-cart-items">
            {shoppingCart.map((item) => (
              <>
                <ShoppingCartItem
                  code={item.productCode}
                  quantity={item.quantity}
                />
                <div className="border-btm" />
              </>
            ))}
            <div className="button-return">
              <button onClick={() => navigate("/")}>
                <ArrowLeft /> Continuer mes achats
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="recap-cart">
            <div className="article">
              <span>Articles ({countQuantityCart(shoppingCart)})</span>
            </div>
            <div>
              <span>Total (HT)</span>
              <span>XX,XX €</span>
            </div>
            <div>
              <span>Dont TVA</span>
              <span>XX,XX €</span>
            </div>
            <div className="delivery">
              Franco de commande à 300€ - Livraison à 25,00€ si Total inférieur
            </div>
            <span />
            <div className="separator" />
            <div className="bold">
              <span>Total (TTC)</span>
              <span>XX,XX €</span>
            </div>
            <div>
              <button onClick={() => navigate("/order")}>Commander</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
